import { Component, OnInit, Input } from '@angular/core';
import { Project } from '../../model/project';
import { ProjectService } from '../project.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { UserService } from '../user.service';
import { User } from '../../model/user';

@Component({
  selector: 'app-project-preview',
  templateUrl: './project-preview.component.html',
  styleUrls: ['./project-preview.component.scss']
})

export class ProjectPreviewComponent implements OnInit {
  title = 'ProjectPreview';
  @Input() project: Project;
  busy: Subscription;
  identity: User;
  logged: boolean;

  constructor(
    private projectService: ProjectService,
    private router: Router,
    public auth: AuthService,
    public userService: UserService
    ) {
      auth.handleAuthentication();
      this.identity = this.userService.identity;
    }

  ngOnInit() {
     setTimeout(() => {
      if (!this.userService.isTokenExpired()) {
      this.identity = this.userService.identity;
      this.logged = true;
      } else {
      this.identity = {};
      this.logged = false;
      }
    }, 300);
  }


  deleteProject() {
    let answer: boolean = confirm(`Delete project ${this.project.title}?`);
    if (answer) {
      this.busy = this.projectService.deleteProject(this.project._id).subscribe(router => this.router.navigate(["/projects"]));
      setTimeout(() => {
        window.location.reload();
      }, 500);

    } else {
      this.router.navigate(['/projects']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/project-preview/project-preview.component.ts